import { Month } from 'libs/time';
import { useFormContext } from 'react-hook-form';

export function useFilterPeriod() {
  const { watch } = useFormContext();
  const periodValue = watch('period');
  return Month.createOrThrow(periodValue);
}
